import { defineStore } from 'pinia';

export const useAirtableStore = defineStore('airtable', {
    state: () => ({
        sessions: [],
        speakers: [],
        sponsors: [],
        tags: [],
        targetedAgendas: [],
        loading: false,
    }),
    actions: {
        init({ sessions, speakers, sponsors, tags, targetedAgendas }) {
            this.sessions = sessions;
            this.speakers = speakers;
            this.sponsors = sponsors;
            this.tags = tags;
            this.targetedAgendas = targetedAgendas;
        },
        async fetchSessions() {
            this.loading = true;
            try {
                if (this.sessions.length) return;
                const { data: sessions } = await useAsyncData('air-table-sessions', () => $fetch('/api/v1/sessions'));
                // const sessions = await $fetch('/api/v1/sessions');
                this.sessions = sessions;
            } catch (error) {
                console.error('Error fetching sessions:', error);
            } finally {
                this.loading = false;
            }
        },
        async fetchTags() {
            this.loading = true;
            try {
                if (typeof this.tags === 'object' && Object.keys(this.tags).length) return;
                const { data: tags } = await useAsyncData('air-table-tags', () => $fetch('/api/v1/tags'));
                // const tags = await $fetch('/api/v1/tags');
                this.tags = tags;
            } catch (error) {
                console.error('Error fetching tags:', error);
            } finally {
                // this.loading = false;
            }
        },
        async fetchSpeakers() {
            this.loading = true;
            try {
                if (this.speakers.length) return;
                const { data: speakers } = await useAsyncData('air-table-speakers', () => $fetch('/api/v1/speakers'));
                this.speakers = speakers;
            } catch (error) {
                console.error('Error fetching speakers:', error);
            } finally {
                // this.loading = false;
            }
        },
        async fetchSponsors() {
            this.loading = true;
            try {
                if (this.sponsors.length) return;
                const { data: sponsors } = await useAsyncData('air-table-sponsors', () => $fetch('/api/v1/sponsors'));
                // const sponsors = await $fetch('/api/v1/sponsors');
                this.sponsors = sponsors;
            } catch (error) {
                console.error('Error fetching sponsors:', error);
            } finally {
                // this.loading = false;
            }
        },
        async fetchTargetedAgendas() {
            this.loading = true;
            try {
                if (this.targetedAgendas.length) return;
                const { data: targetedAgendas } = await useAsyncData('air-table-targeted-agendas', () =>
                    $fetch('/api/v1/targeted-agendas')
                );
                // const targetedAgendas = await $fetch('/api/v1/targeted-agendas');
                this.targetedAgendas = targetedAgendas;
            } catch (error) {
                console.error('Error fetching targetedAgendas:', error);
            } finally {
                // this.loading = false;
            }
        },
        async fetchData() {
            this.loading = true;
            try {
                await Promise.all([
                    this.fetchSessions(),
                    this.fetchSpeakers(),
                    this.fetchSponsors(),
                    this.fetchTags(),
                    this.fetchTargetedAgendas(),
                ]);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },
    },
});
